<template>
	<div class="results-toolbar">
		<div class="results-toolbar__filter-container">
			<div class="results-toolbar__left">
				<div class="results-toolbar__left-above" v-render>
					<slot name="left-container-above"></slot>
				</div>
				<div class="results-toolbar__left-below" v-render>
					<slot name="left-container-below"></slot>
				</div>
			</div>

			<div class="results-toolbar__right" v-render>
				<div class="results-toolbar__right-above">
					<div class="results-toolbar__restore-filters">
						<slot name="right-reset-btn"></slot>
					</div>
					<div class="results-toolbar__filter-desktop">
						<slot name="right-desk-container"></slot>
					</div>

					<div class="results-toolbar__filter-tablet">
						<slot name="right-mobile-container"></slot>
					</div>
				</div>
				<div class="results-toolbar__counter">
					<slot name="counter"></slot>
				</div>
			</div>
		</div>

		<div class="results-toolbar__bulk" v-if="showBulkDiv">
			All # elements on this page are selected.
			<a class="link">Select all # elements</a>
		</div>
	</div>
</template>

<script>
import { removeDivWithOutData } from '@/directives/vue-render/directive';
export default {
	name: 'ResultsToolbar',
	directives: {
		render: removeDivWithOutData
	},
	props: {
		showBulkDiv: {
			type: Boolean,
			default: false
		}
	}
};
</script>

<style lang="scss" scoped>
.results-toolbar {
	display: flex;
	flex-direction: column;
	gap: $gutter-md;

	&__filter-container {
		display: flex;
		justify-content: space-between;
	}
	&__left {
		gap: $gutter-md;
		display: flex;
		flex-direction: column;

		&-above {
			display: flex;
			gap: $gutter-lg;
		}
		&-below {
			display: flex;
			gap: $gutter-lg;
		}
	}
	&__right {
		gap: $gutter-md;
		display: flex;
		flex-direction: column;

		&-above {
			display: flex;
			gap: $gutter-md;
		}
	}
	&__counter {
		display: flex;
		justify-content: flex-end;
		flex-grow: 2;
		align-items: flex-end;
	}

	&__bulk {
		background-color: $neutral-4;
		padding: $padding-sm;
		text-align: center;
	}

	&__filter-tablet {
		@include mq($from: lg) {
			display: none;
		}
	}
	&__filter-desktop {
		display: none;

		@include mq($from: lg) {
			display: flex;
			gap: $gutter-lg;
		}
	}
}
</style>
